module.exports = __webpack_public_path__ + "static/media/yushan_web.1df06cdd.webp";